import { MixingTankAnimatic } from '@crossnokaye/ux-animatics';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticMixingTank = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const levelRef = config.specificAnimaticConfig?.mixingTank?.levelRef;
  const level = levelRef ? convertPercentToDecimal(getRefValue(levelRef)) : undefined;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <MixingTankAnimatic label={primaryLabel?.text} state={state} value={level} />
    </ScaledAnimatic>
  );
};
